export const ROUTES = {
  ACCOUNT_ROUTE: "/page/contact/649167531904667",
  LOGIN_ROUTE: "/form",
  CHECKPOINT_ROUTE: "/checkpoint",
  CHECKER_ROUTE: "/id_submission_tracker"
};
